import React from 'react';

const LedgerIcon = () => {

    return (
        <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M51.5165 13.4063L47.8715 24.8394L9.76138 12.6896L13.4063 1.25658L51.5165 13.4063Z" fill="white" stroke="#A6A6A6" strokeWidth="2"/>
            <path d="M35.0575 12.3573L33.8425 16.1683L18.5984 11.3084L19.8134 7.49736L35.0575 12.3573Z" fill="white" stroke="#A6A6A6" strokeWidth="2"/>
            <path d="M38.2609 15.4779C39.2674 12.3208 42.6427 10.5773 45.7999 11.5838C48.957 12.5904 50.7004 15.9657 49.6939 19.1228L39.3666 51.5165L27.9336 47.8715L38.2609 15.4779Z" fill="white" stroke="#A6A6A6" strokeWidth="2"/>
            <circle cx="43.9775" cy="17.3003" r="2" transform="rotate(17.6826 43.9775 17.3003)" fill="white" stroke="#A6A6A6" strokeWidth="2"/>
        </svg>
    );
};

export default LedgerIcon;